define('views/layouts/layout-body',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'toastr',
    // services
    'services/loading',
    // views
    'views/app/custom-head-style',
    'views/layouts/layout-loading',
    // Templates
    'text!templates/layouts/layout-body.html'
], function(
    // Libs
    _, Backbone, Mustache, U, Toastr,
    // services
    Loading,
    // views
    VCustomHeadStyle,
    VLayoutLoading,
    // Templates
    TLayoutBody
) {

    var VLayoutBody = Backbone.View.extend({
        el: "body",
        template: TLayoutBody,

        regions: {
            loading: "#loading",
            content: "#app",
        },

        initialize: function() {

            // Inistialize Views
            this.view = {
                style: new VCustomHeadStyle(),
                loading: new VLayoutLoading()
            };

            this.listenTo(Loading, {
                'change:loading': this.onLoadingStateChange
            });

            window.addEventListener('native.keyboardshow', this.onShowSoftKeyboard);
            // window.addEventListener('native.keyboardhide', this.onHideSoftKeyboard);

        },

        render: function() {
            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template));
            var view = this.view;
            // get the element related to region selectors
            this.generateZones()
                .assign(view.loading, this.zone.$loading);
            view.style.render();

            // Exemple of notification using toastr.
            if (window.location.href.indexOf('login') === -1) { // Don't want this to display on login screen.
                this.showNotification('info'); // 'info', 'success', 'error' or 'warning'
            }

            return this.renderContent();
        },

        renderContent: function() {
            var content = this.getContent();
            if (content) {
                this.zone.$content
                    .empty()
                    .append(content.render().el);
            }
            return this;
        },

        getContent: function() {
            return this.view.content;
        },

        setContent: function(view) {
            var viewObj = this.view,
                content = viewObj.content;
            if (content !== view) {
                if (content) content.remove();

                viewObj.content = view;
                this.renderContent();
            }
        },

        showLoading: function(value) {
            this.zone.$content.toggleClass('blur', value);
            this.view.loading.toggle(value);
        },

        showNotification: function(type) {
            // Exemple of toast notification.
            // https://github.com/CodeSeven/toastr
            Toastr.options.timeOut = 0; // 0 = sticky
            Toastr.options.positionClass = "toast-bottom-right";
            Toastr.options.newestOnTop = false;
            Toastr.options.showMethod = "fadeIn";
            Toastr.options.tapToDismiss = false;
            Toastr.options.closeButton = true;
            //eval("Toastr." + type + "('Ceci est un exemple de notification de type : ' + type, 'Titre de la notification')");
        },

        ////////////
        // events //
        ////////////
        onLoadingStateChange: function(state, value, options) {
            this.showLoading(value);
        },

        onShowSoftKeyboard: function(e) {
            var focused = document.activeElement;
            if (focused) {
                // false is the bottom of the visible area
                // so it scroll if necessary to have the field closer
                // to the soft keyboard
                focused.scrollIntoView(false);
            }
        },
        // onHideSoftKeyboard: function(e) {
        // },

    });

    return VLayoutBody;
});

